import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import * as ReactHighcharts from "react-highcharts";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";

const GrowthChurnPanel = () => {
  const metrics = useCustomQuery({
    queryKey: ["subscriptionChurnAndGrowth"],
    queryFn: () => window.CoreApi.AdminOne.SubscriptionChurnAndGrowth().then(res => res.data.data),
    initialData: [],
  });

  return <SectionPanel.Panel
    collapsible={{ start: "closed", uniqueRowId: "growth-churn-panel", persist: true }}
    header={<PanelSegment.Title title={"Growth / Churn"} />}
  >
    <ReactHighcharts
      config={{
        chart: {
          style: {
            fontFamily: "inherit"
          },
          type: "column",
          backgroundColor: "transparent"
        },
        series: [
          {
            name: "Growth",
            data: metrics.data?.map(item => item.growth) ?? [],
            color: "#4CAF50" // Green color for growth
          },
          {
            name: "Churn",
            data: metrics.data?.map(item => item.churn) ?? [],
            color: "#F44336" // Red color for churn
          }
        ],

        title: {
          text: ""
        },
        xAxis: {
          categories: metrics.data?.map(item => `${item.year} Q${item.quarter}`) ?? [],
        },
        yAxis: {
          title: {
            text: "nr of clients"
          }
        },
        credits: {
          enabled: false
        }
      }}
    />
  </SectionPanel.Panel>;
};

export default GrowthChurnPanel;
